import { AvatarUpload } from "../../../../../components/ui-kit/AvatarUpload";
import { ImageUploader } from "../../../../../components/ui-kit/ImageUploader";
import { GRID_FORM_CONFIG_T } from "../../../../../common/FormGenerator"

export type FiltrationBlockName =
    | "avatar"
    | "images"

export type AvatarUploadFieldProps = {
    onCropSaved?: (file: File) => Promise<string | void>
    hideRemove?: boolean
}

export const avatarConfig = (
    avatarUploadProps: AvatarUploadFieldProps = {},
): GRID_FORM_CONFIG_T<{ avatarUrl: string | File | null }> => [
    [
        {
            id: 1,
            controllerName: "avatarUrl",
            RenderElement: AvatarUpload,
            renderProps: () => avatarUploadProps,
        }
    ],
];

export const imagesConfig = [
    [
        {
            id: 2,
            controllerName: "images",
            RenderElement: ImageUploader,
            renderProps: () => ({}),
        }
    ],
];


const formConfigs: Record<Exclude<FiltrationBlockName, 'avatar'>, GRID_FORM_CONFIG_T<any>> = {
    images: imagesConfig,
}

export const getFormConfig = (
    blockName: FiltrationBlockName,
    avatarUploadProps?: AvatarUploadFieldProps,
) => {
    if (blockName === 'avatar') {
        return avatarConfig(avatarUploadProps)
    }
    return formConfigs[blockName]
}

export const getDynamicConfig = (blockName: FiltrationBlockName, index: number, arrayName: string): GRID_FORM_CONFIG_T<any> => {
    const config = getFormConfig(blockName);
    
    return [...config.map(row => 
        row.map(field => ({
            ...field,
            controllerName: `${arrayName}.${index}.${field.controllerName}`
        }))
    )];
};
